import { render, staticRenderFns } from "./channelCheckout.vue?vue&type=template&id=1332155a"
import script from "./channelCheckout.vue?vue&type=script&lang=js"
export * from "./channelCheckout.vue?vue&type=script&lang=js"
import style0 from "./channelCheckout.vue?vue&type=style&index=0&id=1332155a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports